<template>

    <div class="employee-tab-inner company-form-container px-3">
        <template v-if="permission == 2">
            <b-alert v-model="hasDraft" class="position-fixed fixed-top m-0 rounded-0" style="z-index: 2000;"
                variant="info" dismissible>System Alert : Draft data is waiting for your approval!</b-alert>
        </template>
        <div class="row no-gutters py-2 mb-3 mt-3">
            <div class="col-sm-6 company-form-box-title"> Migrated Payroll History <span
                    style="font-style: italic;text-transform: lowercase;font-size: 12px;"> * (not calculated using this
                    system)
                </span> </div>
            <template v-if="permission >= 2">
                <div class="col-sm-6 cursor-pointer text-right company-form-box-title" @click="addNew()"><button
                        class="btn btn-block btn-secondary tab-button"> Add Payroll History </button></div>
            </template>
        </div>

        <!-- Mustafijur: 13-05-2026: Starts -->
        <!-- alpha fix- removed class ibox  -->
        <div class="col-sm-12  px-0  no-shadow employee-table-wrapper">

            <b-overlay :show="showoverlay_list" class="">
                <!-- alfa fix- removed empty contaion from here and put that on templte  -->
                <div class="">

                    <table class="table">
                        <thead>
                            <tr class="table-head">
                                <td>Fiscal Year </td>
                                <td>Basic Salary</td>
                                <td>Medical Allowance</td>
                                <td>House Rent</td>
                                <td>Conveyance</td>
                                <td>Other Taxable Income</td>
                                <td> Total Tax Paid</td>
                                <td>Last Activity <span
                                        class="custom-date-indicator d-block ess-date-indicator">(YYYY-MM-DD)</span>
                                </td>
                                <td>Activity By</td>
                                <td v-if="permission >= 2">Action</td>
                            </tr>
                        </thead>
                        <!-- alpha fix- added templete with condition  -->
                        <template v-if="mphs.length > 0">
                            <tbody>
                                <tr class="hover-bg table-row border-bottom mx-2" v-for="mph in mphs" :key="mph.id">
                                    <td class="align-middle list-columns"><b-icon v-if="mph.draft_flg == 1"
                                            icon="arrow-right-circle" scale="1.5" variant="info" animation="fade"
                                            class="pr-1" v-b-tooltip.hover title="Has Draft Data"></b-icon>
                                        <b-icon v-else icon="blank"></b-icon>

                                        {{ mph.fiscal_year }}
                                    </td>

                                    <!-- alpha fix- added class text-right  -->
                                    <td class="align-middle list-columns text-right">
                                        <template v-if="decimal_setting == 'no'">{{
                                            moneyFormat(Math.round(mph.basic_salary)) }}</template>
                                        <template v-else>{{ moneyFormat(mph.basic_salary) }}</template>

                                    </td>

                                         <!-- alpha fix- added class text-right  -->
                                    <td class="align-middle list-columns text-right">
                                        <template v-if="decimal_setting == 'no'">{{
                                            moneyFormat(Math.round(mph.medical_allowance))
                                        }}</template><template v-else>{{ moneyFormat(mph.medical_allowance)
                                            }}</template>
                                    </td>

                                         <!-- alpha fix- added class text-right  -->
                                    <td class="align-middle list-columns text-right">
                                        <template v-if="decimal_setting == 'no'">{{
                                            moneyFormat(Math.round(mph.house_rent))
                                        }}</template><template v-else>{{ moneyFormat(mph.house_rent) }}</template>
                                    </td>

                                         <!-- alpha fix- added class text-right  -->
                                    <td class="align-middle list-columns text-right">
                                        <template v-if="decimal_setting == 'no'">{{
                                            moneyFormat(Math.round(mph.conveyance))
                                        }}</template><template v-else>{{ moneyFormat(mph.conveyance) }}</template>
                                    </td>

                                         <!-- alpha fix- added class text-right  -->
                                    <td class="align-middle list-columns text-right">
                                        <template v-if="decimal_setting == 'no'">{{
                                            moneyFormat(Math.round(mph.other_taxable_income))
                                        }}</template><template v-else>{{ moneyFormat(mph.other_taxable_income)
                                            }}</template>
                                    </td>

                                         <!-- alpha fix- added class text-right  -->
                                    <td class="align-middle list-columns text-right">
                                        <template v-if="decimal_setting == 'no'">{{
                                            moneyFormat(Math.round(mph.total_tax_paid))
                                        }}</template><template v-else>{{ moneyFormat(mph.total_tax_paid)
                                            }}</template>
                                    </td>

                                    <td class="align-middle list-columns">
                                        <template v-if="mph.updated_at != null">{{ formatMe(mph.updated_at)
                                        }}</template>
                                        <template v-else>{{ formatMe(mph.created_at) }}</template>
                                    </td>

                                    <td class="align-middle list-columns">
                                        <template v-if="mph.updated_by == null">
                                            Not Available
                                        </template>
                                        <template v-else>
                                            {{ mph.updated_by }}
                                        </template>
                                    </td>

                                    <td class="list-columns align-middle" v-if="permission >= 2">
                                        <b-button-toolbar class="position-relative text-right justify-content-end"
                                            v-if="mph.flg == 1">
                                            <a id="actionDropdown"
                                                class="dropdown-toggle clearfix action-dropdown-toggle"
                                                style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false"><b-icon
                                                    icon="three-dots-vertical"></b-icon></a>
                                            <div class="dropdown-menu action-dropdown-menu"
                                                aria-labelledby="actionDropdown">
                                                <b-button-group class="mr-1">
                                                    <b-button class="text-left" title="Edit MPH"
                                                        @click="editMph(mph.id)">
                                                        <i class="fa fa-pencil-alt"></i> Edit
                                                    </b-button>
                                                    <b-button class="text-left" title="Delete MPH"
                                                        @click="deleteMph(mph.id)" v-if="permission == 2">
                                                        <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                                                    </b-button>
                                                </b-button-group>
                                            </div>
                                        </b-button-toolbar>
                                        <div class="text-center float-right" v-else
                                            title="This entry can't be edited or deleted since a payrun has been approved after this was listed."
                                            v-b-tooltip placement="right">
                                            <b-icon icon="info-circle"></b-icon>
                                        </div>
                                    </td>

                                </tr>
                            </tbody>
                        </template>

                        <!-- alpha fix- added this  -->
                        <template v-else>
                            <tbody>
                                <tr class="hover-bg table-row">
                                    <td class="cursor-pointer trz_relative text-center" colspan="10">No Migrated Payroll
                                        History Found!</td>
                                </tr>
                            </tbody>
                        </template>

                    </table>

                </div>
                <!-- alpha fix- commented this   -->
                <!-- <div class=" p-4 text-center" v-else>
                    No Migrated Payroll History Found!
                </div> -->
            </b-overlay>
        </div> <!-- Mustafijur: 13-05-2026: Ends -->

        <!-- alpha fix- maked modal title dynamic  -->
        <b-modal id="bv-modal-example" size="lg" :modal-class="'w-600'" hide-footer :title=migrated_payroll_title>

            <b-form @submit.stop.prevent="onSubmit">
                <div class="clearfix">

                    <div class="col-md-12 float-left">
                        <input type="hidden" v-model="fake" />
                        <input type="hidden" v-model="fdata.id" name="id">



                        <b-form-group id="fiscal_year-group" label="Fiscal Year" class="required-field"
                            label-for="fiscal_year">
                            <b-input-group>
                                <b-form-select class="radius-8" id="fiscal_year" name="fiscal_year"
                                    v-model="fdata.fiscal_year" v-validate="{ required: true }" :options="fiscal_years"
                                    :state="validateState('fiscal_year')" aria-describedby="fiscal_year-feedback"
                                    data-vv-as="Fiscal Year"></b-form-select>
                                <b-input-group-append v-if="draft_data['fiscal_year']" v-b-tooltip.hover
                                    :title="xdata['fiscal_year']"><b-icon icon="pencil-square"
                                        class="ml-1 mt-2"></b-icon></b-input-group-append>
                                <b-form-invalid-feedback id="fiscal_year-feedback">{{ veeErrors.first('fiscal_year')
                                }}</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>


                        <b-form-group id="basic_salary-group" label="Basic Salary ( ৳ )" class="required-field"
                            label-for="basic_salary">
                            <b-input-group>
                                <b-form-input class="radius-8" id="basic_salary" name="basic_salary"
                                    v-model="fdata.basic_salary" v-validate="{ required: true, decimal: 2 }"
                                    :state="validateState('basic_salary')" aria-describedby="basic_salary-feedback"
                                    data-vv-as="Basic Salary"></b-form-input>
                                <b-input-group-append v-if="draft_data['basic_salary']" v-b-tooltip.hover
                                    :title="xdata['basic_salary']"><b-icon icon="pencil-square"
                                        class="ml-1 mt-2"></b-icon></b-input-group-append>
                                <b-form-invalid-feedback id="basic_salary-feedback">{{ veeErrors.first('basic_salary')
                                }}</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>


                        <b-form-group id="medical_allowance-group" label="Medical Allowance ( ৳ )"
                            class="required-field" label-for="medical_allowance">
                            <b-input-group>
                                <b-form-input class="radius-8" id="medical_allowance" name="medical_allowance"
                                    v-model="fdata.medical_allowance" v-validate="{ required: true, decimal: 2 }"
                                    :state="validateState('medical_allowance')"
                                    aria-describedby="medical_allowance-feedback"
                                    data-vv-as="Medical Allowance"></b-form-input>
                                <b-input-group-append v-if="draft_data['medical_allowance']" v-b-tooltip.hover
                                    :title="xdata['medical_allowance']"><b-icon icon="pencil-square"
                                        class="ml-1 mt-2"></b-icon></b-input-group-append>
                                <b-form-invalid-feedback id="medical_allowance-feedback">{{
                                    veeErrors.first('medical_allowance')
                                }}</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>


                        <b-form-group id="house_rent-group" label="House Rent ( ৳ )" class="required-field"
                            label-for="house_rent">
                            <b-input-group>
                                <b-form-input class="radius-8" id="house_rent" name="house_rent"
                                    v-model="fdata.house_rent" v-validate="{ required: true, decimal: 2 }"
                                    :state="validateState('house_rent')" aria-describedby="house_rent-feedback"
                                    data-vv-as="House Rent"></b-form-input>
                                <b-input-group-append v-if="draft_data['house_rent']" v-b-tooltip.hover
                                    :title="xdata['house_rent']"><b-icon icon="pencil-square"
                                        class="ml-1 mt-2"></b-icon></b-input-group-append>
                                <b-form-invalid-feedback id="house_rent-feedback">{{ veeErrors.first('house_rent')
                                }}</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>


                        <b-form-group id="conveyance-group" label="Conveyance ( ৳ )" class="required-field"
                            label-for="conveyance">
                            <b-input-group>
                                <b-form-input class="radius-8" id="conveyance" name="conveyance"
                                    v-model="fdata.conveyance" v-validate="{ required: true, decimal: 2 }"
                                    :state="validateState('conveyance')" aria-describedby="conveyance-feedback"
                                    data-vv-as="Conveyance"></b-form-input>
                                <b-input-group-append v-if="draft_data['conveyance']" v-b-tooltip.hover
                                    :title="xdata['conveyance']"><b-icon icon="pencil-square"
                                        class="ml-1 mt-2"></b-icon></b-input-group-append>
                                <b-form-invalid-feedback id="conveyance-feedback">{{ veeErrors.first('conveyance')
                                }}</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>


                        <b-form-group id="other_taxable_income-group" label="Other Taxable Income ( ৳ )"
                            class="required-field" label-for="other_taxable_income">
                            <b-input-group>
                                <b-form-input class="radius-8" id="other_taxable_income" name="other_taxable_income"
                                    v-model="fdata.other_taxable_income" v-validate="{ required: true, decimal: 2 }"
                                    :state="validateState('other_taxable_income')"
                                    aria-describedby="other_taxable_income-feedback"
                                    data-vv-as="Other Taxable Income"></b-form-input>
                                <b-input-group-append v-if="draft_data['other_taxable_income']" v-b-tooltip.hover
                                    :title="xdata['other_taxable_income']"><b-icon icon="pencil-square"
                                        class="ml-1 mt-2"></b-icon></b-input-group-append>
                                <b-form-invalid-feedback id="other_taxable_income-feedback">{{
                                    veeErrors.first('other_taxable_income') }}</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>


                        <b-form-group id="total_tax_paid-group" label="Total Tax Paid ( ৳ )" class="required-field"
                            label-for="total_tax_paid">
                            <b-input-group>
                                <b-form-input class="radius-8" id="total_tax_paid" name="total_tax_paid"
                                    v-model="fdata.total_tax_paid" v-validate="{ required: true, decimal: 2 }"
                                    :state="validateState('total_tax_paid')" aria-describedby="total_tax_paid-feedback"
                                    data-vv-as="Total Tax Paid"></b-form-input>
                                <b-input-group-append v-if="draft_data['total_tax_paid']" v-b-tooltip.hover
                                    :title="xdata['total_tax_paid']"><b-icon icon="pencil-square"
                                        class="ml-1 mt-2"></b-icon></b-input-group-append>
                                <b-form-invalid-feedback id="total_tax_paid-feedback">{{
                                    veeErrors.first('total_tax_paid')
                                }}</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>

                    </div>
                </div>

                <div class="col-md-12 text-center mt-4 mb-4 clearfix" style="margin-right: 18px;"
                    v-if="permission >= 2">
                    <b-button class="border rounded  py-1 px-5 mt-4 ml-2 custom-wizard-btn btn-primary"
                        variant="success" @click="clearDraft(fdata.id)"
                        v-if="(permission == 2) && (fdata.id > 0)">Reset</b-button>
                    <b-button class="border rounded  py-1 px-5 mt-4 ml-2 btn-primary" type="submit"
                        variant="success">Submit</b-button>
                </div>

            </b-form>
        </b-modal>

        <!-- Draft section start here -->

        <!-- apha fix- maked title dynamic  -->
        <b-modal id="bv-modal-draft-mph" size="lg" hide-footer :title=migrated_payroll_title>
            <b-form @submit.stop.prevent="saveDraftMph">
                <div class="clearfix">

                    <div class="col-md-12 float-left">

                        <input type="hidden" v-model="draftdata.id" name="id">
                        <b-form-group id="fiscal_year-group" label="Fiscal Year" class="required-field"
                            label-for="fiscal_year">
                            <!--<b-form-input id="fiscal_year" name="fiscal_year" v-model="fdata.fiscal_year" readonly></b-form-input>-->
                            <b-form-select id="fiscal_year" name="fiscal_year" v-model="draftdata.fiscal_year"
                                :options="fiscal_years"></b-form-select>
                        </b-form-group>

                        <b-form-group id="basic_salary-group" label="Basic Salary ( ৳ )" class="required-field"
                            label-for="basic_salary">
                            <b-form-input id="basic_salary" name="basic_salary" v-model="draftdata.basic_salary"
                                v-validate="{ required: true, decimal: 2 }" :state="validateState('basic_salary')"
                                aria-describedby="basic_salary-feedback" data-vv-as="Basic Salary"></b-form-input>
                            <b-form-invalid-feedback id="basic_salary-feedback">{{ veeErrors.first('basic_salary')
                            }}</b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group id="medical_allowance-group" label="Medical Allowance ( ৳ )"
                            class="required-field" label-for="medical_allowance">
                            <b-form-input id="medical_allowance" name="medical_allowance"
                                v-model="draftdata.medical_allowance" v-validate="{ required: true, decimal: 2 }"
                                :state="validateState('medical_allowance')"
                                aria-describedby="medical_allowance-feedback"
                                data-vv-as="Medical Allowance"></b-form-input>
                            <b-form-invalid-feedback id="medical_allowance-feedback">{{
                                veeErrors.first('medical_allowance')
                            }}</b-form-invalid-feedback>
                        </b-form-group>


                        <b-form-group id="house_rent-group" label="House Rent ( ৳ )" class="required-field"
                            label-for="house_rent">
                            <b-form-input id="house_rent" name="house_rent" v-model="draftdata.house_rent"
                                v-validate="{ required: true, decimal: 2 }" :state="validateState('house_rent')"
                                aria-describedby="house_rent-feedback" data-vv-as="House Rent"></b-form-input>
                            <b-form-invalid-feedback id="house_rent-feedback">{{ veeErrors.first('house_rent')
                            }}</b-form-invalid-feedback>
                        </b-form-group>


                        <b-form-group id="conveyance-group" label="Conveyance ( ৳ )" class="required-field"
                            label-for="conveyance">
                            <b-form-input id="conveyance" name="conveyance" v-model="draftdata.conveyance"
                                v-validate="{ required: true, decimal: 2 }" :state="validateState('conveyance')"
                                aria-describedby="conveyance-feedback" data-vv-as="Conveyance"></b-form-input>
                            <b-form-invalid-feedback id="conveyance-feedback">{{ veeErrors.first('conveyance')
                            }}</b-form-invalid-feedback>
                        </b-form-group>


                        <b-form-group id="other_taxable_income-group" label="Other Taxable Income ( ৳ )"
                            class="required-field" label-for="other_taxable_income">
                            <b-form-input id="other_taxable_income" name="other_taxable_income"
                                v-model="draftdata.other_taxable_income" v-validate="{ required: true, decimal: 2 }"
                                :state="validateState('other_taxable_income')"
                                aria-describedby="other_taxable_income-feedback"
                                data-vv-as="Other Taxable Income"></b-form-input>
                            <b-form-invalid-feedback id="other_taxable_income-feedback">{{
                                veeErrors.first('other_taxable_income') }}</b-form-invalid-feedback>
                        </b-form-group>


                        <b-form-group id="total_tax_paid-group" label="Total Tax Paid ( ৳ )" class="required-field"
                            label-for="total_tax_paid">
                            <b-form-input id="total_tax_paid" name="total_tax_paid" v-model="draftdata.total_tax_paid"
                                v-validate="{ required: true, decimal: 2 }" :state="validateState('total_tax_paid')"
                                aria-describedby="total_tax_paid-feedback" data-vv-as="Total Tax Paid"></b-form-input>
                            <b-form-invalid-feedback id="total_tax_paid-feedback">{{ veeErrors.first('total_tax_paid')
                            }}</b-form-invalid-feedback>
                        </b-form-group>

                    </div>
                </div>

                <div class="mt-4 ml-4 mb-4 clearfix" style="margin-right: 18px;">
                    <b-button class="border rounded float-right py-1 px-5 mt-4 ml-2" type="submit"
                        variant="success">Submit</b-button>
                </div>

            </b-form>
        </b-modal>

        <div class="col-sm-12  px-0 mt-5" v-if="draft_mphs.length > 0">
            <div class="px-3 mb-2 company-form-box-title">New Migrated Payroll History Data (Waiting for Approval)</div>
            <b-overlay :show="showoverlay_list" class="card no-shadow">

                <div class="mx-2 p-4">

                    <div class="row border-bottom table-head">
                        <div class="col-sm py-1 font-weight-bold align-self-center">
                            Fiscal Year
                        </div>
                        <div class="col-sm text-center py-1 font-weight-bold align-self-center">
                            Basic Salary
                        </div>
                        <div class="col-sm text-center py-1 font-weight-bold align-self-center">
                            Medical Allowance
                        </div>
                        <div class="col-sm text-center py-1 font-weight-bold align-self-center">
                            House Rent
                        </div>
                        <div class="col-sm text-center py-1 font-weight-bold align-self-center">
                            Conveyance
                        </div>
                        <div class="col-sm text-center py-1 font-weight-bold align-self-center">
                            Other Taxable Income
                        </div>
                        <div class="col-sm text-center py-1 font-weight-bold align-self-center">
                            Total Tax Paid
                        </div>

                        <div class="col-sm text-center py-1 font-weight-bold align-self-center">
                            Last Activity
                            <span class="custom-date-indicator">(YYYY-MM-DD)</span>
                        </div>

                        <div class="col-sm text-center py-1 font-weight-bold align-self-center">
                            Activity By
                        </div>

                        <div class="col-sm text-right py-1 font-weight-bold align-self-center" v-if="permission >= 2">
                            Action
                        </div>
                    </div>

                    <div class="row hover-bg table-row border-bottom py-2" v-for="mph in draft_mphs" :key="mph.id">


                        <div class="col-sm text-uppercase py-1">
                            {{ mph.fiscal_year }}
                        </div>
                        <div class="col-sm text-right py-1">
                            <template v-if="decimal_setting == 'no'">{{ moneyFormat(Math.round(mph.basic_salary))
                                }}</template><template v-else>{{ moneyFormat(mph.basic_salary) }}</template>
                        </div>
                        <div class="col-sm text-right py-1">
                            <template v-if="decimal_setting == 'no'">{{ moneyFormat(Math.round(mph.medical_allowance))
                                }}</template><template v-else>{{ moneyFormat(mph.medical_allowance) }}</template>
                        </div>
                        <div class="col-sm text-right py-1">
                            <template v-if="decimal_setting == 'no'">{{ moneyFormat(Math.round(mph.house_rent))
                                }}</template><template v-else>{{ moneyFormat(mph.house_rent) }}</template>
                        </div>
                        <div class="col-sm text-right py-1">
                            <template v-if="decimal_setting == 'no'">{{ moneyFormat(Math.round(mph.conveyance))
                                }}</template><template v-else>{{ moneyFormat(mph.conveyance) }}</template>
                        </div>
                        <div class="col-sm text-right py-1">
                            <template v-if="decimal_setting == 'no'">{{
                                moneyFormat(Math.round(mph.other_taxable_income)) }}</template><template v-else>{{
                                    moneyFormat(mph.other_taxable_income) }}</template>
                        </div>
                        <div class="col-sm text-right py-1">
                            <template v-if="decimal_setting == 'no'">{{ moneyFormat(Math.round(mph.total_tax_paid))
                                }}</template><template v-else>{{ moneyFormat(mph.total_tax_paid) }}</template>
                        </div>

                        <div class="col-sm text-center">
                            <template v-if="mph.updated_at != null">{{ formatMe(mph.updated_at) }}</template>
                            <template v-else>{{ formatMe(mph.created_at) }}</template>
                        </div>

                        <div class="col-sm text-uppercase py-1">
                            <template v-if="mph.updated_by == null">
                                Not Available
                            </template>
                            <template v-else>
                                {{ mph.updated_by }}
                            </template>
                        </div>

                        <div class="col-sm text-right clearfix" v-if="permission >= 2">
                            <b-button-toolbar class="position-relative text-right justify-content-end">
                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                    style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false"><b-icon
                                        icon="three-dots-vertical"></b-icon></a>
                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                    <b-button-group class="mr-1">
                                        <b-button class="text-left" v-if="permission == 2" title="Approve"
                                            @click="approveDraftMph(mph.id)">
                                            <b-icon icon="check2" class="mr-2" aria-hidden="true"></b-icon>Approve
                                        </b-button>
                                        <b-button class="text-left" title="Edit MPH" @click="editDraftMph(mph.id)">
                                            <i class="fa fa-pencil-alt"></i> Edit
                                        </b-button>
                                        <b-button class="text-left" title="Delete MPH" @click="deleteDraftMph(mph.id)">
                                            <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                                        </b-button>
                                    </b-button-group>
                                </div>
                            </b-button-toolbar>
                        </div>
                    </div>
                </div>
            </b-overlay>
        </div>
    </div>

</template>
<script>
import moment from 'moment';

export default {

    mounted() {

        this.permission = this.$acl['employee/mph'];
    },
    props: ['flg'],
    data() {

        return {
            itabIndex: 0,
            fiscal_year: this.getCurrentFinancialYear(),

            mphs: [],
            draft_mphs: [],

            successmsg: null,
            errormsg: [],
            fdata: { fiscal_year: this.getCurrentFinancialYear(), amount: null, id: null },
            xdata: {},
            draftdata: {},

            fiscal_years: this.$fiscal_year_options,

            decimal_setting: 'yes',

            permission: 0,

            hasDraft: false,
            draft_data: [],

            showoverlay_list: false,

            fake: 0,

            // alpha fix- added this
           migrated_payroll_title:" Add Migrated Payroll History" ,

        }
    },
    methods: {
        formatMe(d) {
            return moment(d).format('YYYY-MM-DD hh:mm:ss A');
        },
        moneyFormat(amount) {
            var money = Number(amount);
            money = money.toLocaleString();
            if (this.decimal_setting == 'yes' || this.decimal_setting == '')
                if (money.indexOf(".") < 0)
                    money = money + '.00';
            return money;
        },
        clearDraft: function (x) {
            let currentObj = this;
            let formData = new FormData();
            formData.append('id', x);
            formData.append('type', 3);
            axios.post(this.$api_url + '/clear/draft', formData)
                .then(function (response) {

                    this.$bvToast.toast('Draft data has been cleard.', {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                    });

                    this.editMph(x);
                    this.getMphs();

                }.bind(this))
                .catch(function (error) {
                    currentObj.serverError(error);
                });
        },
        getDraftMphs: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;

            axios.get(this.$api_url + '/list/draft', {
                params: {
                    type: 3
                }
            }).then(function (response) {
                this.draft_mphs = response.data;

                if (this.draft_mphs.length > 0)
                    this.hasDraft = true;

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        editDraftMph: function (x) {
            this.addtype = false;
            if (!this.checkNet()) return false;
            let currentObj = this;
            this.showoverlay = true;
            axios.get(this.$api_url + '/details/draft', {
                params: {
                    id: x,
                    type: 3
                }
            }).then(function (response) {
                this.draftdata = response.data;
                this.$validator.reset();
                this.showoverlay = false;
                this.$bvModal.show('bv-modal-draft-mph');
                // alpha fix- added this
                this.migrated_payroll_title = " Edit Migrated Payroll History" ;
            }.bind(this)).catch(function (error) { currentObj.showoverlay = false; currentObj.serverError(error); });;
        },
        saveDraftMph(e) {
            if (!this.checkNet()) return false;
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                e.preventDefault();
                let currentObj = this;
                let formData = new FormData();

                for (let [key, value] of Object.entries(this.draftdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    //console.log(`${key}: ${value}`);
                }

                formData.append('type', 3);

                axios.post(this.$api_url + '/save/draft', formData)
                    .then(function (response) {
                        this.getDraftMphs();
                        this.successmsg = 'Saved!';
                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        this.$bvModal.hide('bv-modal-draft-mph');

                    }.bind(this))
                    .catch(function (error) {
                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                    });
            });
        },
        deleteDraftMph: function (x) {
            if (!this.checkNet()) return false;
            this.$bvModal.msgBoxConfirm('Please confirm you want to delete this Migrated Payroll History.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {
                        this.resetForm();
                        this.showoverlay_list = true;
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);
                        formData.append('type', 3);

                        axios.post(this.$api_url + '/delete/draft', formData).then(function (response) {

                            this.$bvToast.toast(response.data.meg, {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });
                            this.getDraftMphs();
                            this.showoverlay_list = false;

                        }.bind(this)).catch(function (error) { currentObj.showoverlay_list = false; currentObj.serverError(error); });
                    }
                })
        },
        approveDraftMph: function (x) {
            if (!this.checkNet()) return false;
            this.$bvModal.msgBoxConfirm('Please confirm that you want to approve this draft data.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);
                        formData.append('type', 3);

                        axios.post(this.$api_url + '/approve/draft', formData).then(function (response) {

                            this.getMphs();
                            this.getDraftMphs();

                            this.$bvToast.toast('Approved!', {
                                title: `Success`,
                                variant: 'success',
                                solid: true
                            });

                        }.bind(this));
                    }
                })
                .catch(err => {
                    // An error occurred
                })
        },

        getDraftMphData: function (x) {
            if (!this.checkNet()) return false;

            let currentObj = this;
            let formData = new FormData();
            formData.append('id', x);
            formData.append('type', 3);

            axios.post(this.$api_url + '/cdata/draft', formData).then(function (response) {

                this.draft_data = response.data;

                for (let [key, value] of Object.entries(this.draft_data)) {
                    this.fdata[key] = value;
                }

                this.fake = this.fake + 1;

            }.bind(this));
        },



        getMphs: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;

            this.hasDraft = false;

            axios.get(this.$api_url + '/mph/list', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.mphs = response.data;

                var valObj = this.mphs.filter(function (elem) {
                    if (elem.draft_flg == 1) return true;
                });
                if (valObj.length > 0)
                    this.hasDraft = true;

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        editMph: function (x) {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/mph/details', {
                params: {
                    id: x
                }
            }).then(function (response) {
                //this.fdata = response.data;

                for (let [key, value] of Object.entries(response.data)) {
                    this.xdata[key] = value;
                    this.fdata[key] = value;
                }

                this.getDraftMphData(x);

                this.successmsg = null;
                this.$bvModal.show('bv-modal-example');
                // alpha fix- added this
                 this.migrated_payroll_title = " Edit Migrated Payroll History" ;
            }.bind(this)).catch(function (error) { currentObj.serverError(error); });

        },

        deleteMph: function (x) {
            if (!this.checkNet()) return false;
            this.$bvModal.msgBoxConfirm('Please confirm you want to delete this Migrated Payroll History.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {
                        this.resetForm();
                        this.showoverlay_list = true;
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url + '/mph/delete', formData).then(function (response) {

                            if (response.data.status == true) {
                                this.successmsg = response.data.meg;
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });
                                this.getMphs();
                            }
                            this.showoverlay_list = false;

                        }.bind(this)).catch(function (error) { currentObj.showoverlay_list = false; currentObj.serverError(error); });
                    }
                })
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.fdata = { fiscal_year: this.getCurrentFinancialYear(), id: 0 };

            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        addNew() {
            this.resetForm();
            this.$bvModal.show('bv-modal-example');
            // alpha fix- added this
             this.migrated_payroll_title = "Add Migrated Payroll History" ;
        },
        onSubmit(e) {
            if (!this.checkNet()) return false;
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                e.preventDefault();
                let currentObj = this;
                let changed = false;
                const config = {
                    //headers: { 'content-type': 'multipart/form-data' }
                }

                let formData = new FormData();

                if (this.fdata.id == 0) {
                    for (let [key, value] of Object.entries(this.fdata)) {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        console.log(`${key}: ${value}`);
                    }
                }
                else {
                    let changed_data = [];

                    for (let [key, value] of Object.entries(this.fdata)) {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        if (fval == 'null')
                            fval = '';

                        if ((this.fdata[key] != this.xdata[key])) {
                            changed_data = changed_data.concat([{ field: nm, value: fval }]);
                            changed = true;
                        }
                    }


                    if (changed == false) {
                        this.$bvToast.toast('No changed data found.', {
                            title: `Warning`,
                            variant: 'warning',
                            solid: true
                        });


                        return;
                    }

                    formData.append('changed_data', JSON.stringify(changed_data));

                    formData.append('id', this.fdata.id);
                }



                axios.post(this.$api_url + '/mph/save', formData, config)
                    .then(function (response) {
                        this.resetForm();
                        this.getMphs();
                        this.getDraftMphs();
                        this.itabIndex = 1;

                        this.$bvToast.toast("Saved", {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        this.$bvModal.hide('bv-modal-example');

                    }.bind(this))
                    .catch(function (error) {
                        currentObj.serverError(error);
                        //currentObj.errormsg = error.response.data.errors;
                    });
            });
        },
        get_decimal_settings: function () {
            axios.get(this.$api_url + '/decimal-settings')

                .then(function (response) {
                    this.decimal_setting = response.data;
                }.bind(this));
        },

    },
    created: function () {
        this.getMphs();
        this.getDraftMphs();
        this.get_decimal_settings();
    }
}
</script>
